import { FC } from 'react'
import { Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import { useUpdateFormMutation } from '../../../../../store/api/forms-api'
import useErrorModal from '../../../../../hooks/api/use-error-modal'

interface InStockCheckboxProps {
    formDocumentId?: string
    checked?: boolean
    disabled?: boolean
    onSuccess?: () => void
}

const InStockCheckbox: FC<InStockCheckboxProps> = ({
    formDocumentId,
    checked = false,
    disabled = false,
    onSuccess,
}) => {
    const [updateForm, updateState] = useUpdateFormMutation()

    const onChange = async (e: CheckboxChangeEvent) => {
        if (!formDocumentId) return

        const result = await updateForm({
            docId: formDocumentId,
            body: {
                data: {
                    inStock: e.target.checked,
                },
            },
        })

        if (!('error' in result)) {
            onSuccess?.()
        }
    }

    useErrorModal(updateState, 'Не удалось обновить признак наличия формы')

    return (
        <Checkbox
            checked={checked}
            disabled={disabled || !formDocumentId || updateState.isLoading}
            onChange={onChange}
        />
    )
}

export default InStockCheckbox